import { ReactNode } from 'react'
import { FormGroup, Modal } from 'react-bootstrap'
import FormHandler from '../../../utils/Form/FormHandler'
import MultipleFileInputWidget from '../../../utils/Form/Widgets/MultipleFileInputWidget'
import AutocompleteSelect from '../../../utils/Form/Widgets/AutocompleteSelect'

type Props = {
  onHide: () => void
  show: boolean
  refreshFunction?: Function
}

class ManuelFileInputModal extends FormHandler {
  // eslint-disable-next-line
  constructor(props: Props) {
    super(props)
  }

  getApiUrl(): string {
    return '/data_files/manuelInput'
  }
  getSingleUrl(): string | null {
    return null
  }

  getPostData(): object {
    return this.state.entity
  }
  render(): ReactNode {
    let title = 'Manuel File Input'
    var state = this.state as any
    return (
      <Modal
        id='manuel_file_input_modal'
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        size='lg'
        show={this.props.show}
        backdrop={true}
        onHide={this.props.onHide}
      >
        <form
          onSubmit={(event) => {
            this.handleSubmit(event).then((response) => {
              if (this.props.refreshFunction) {
                this.props.refreshFunction()
              }
            })
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <AutocompleteSelect
                title='File Structure'
                name='file_structure'
                autoCompleteTokenUrl='/import_file_structure_template/autocomplete'
                onChange={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state?.entity?.file_structure ?? 0}
                placeholder='Select a file structure'
              />
            </FormGroup>
            <p className='fw-bolder fs-5'>Select csv files to upload and save</p>
            <FormGroup>
              <MultipleFileInputWidget
                fileUploadKeyUrl='/data_files/getManuelFileUploadKey'
                name='files'
                fieldName='fields'
                onChange={(event) => {
                  this.handleInputChange(event)
                }}
                accept='.csv'
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer className='justify-content-end'>
            <button type='submit' className='btn btn-success btn-sm'>
              Save Files
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export { ManuelFileInputModal }
